import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { FormHeader, SectionHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

const lan = getLanguage();

const Index = ({ onClickEdit, onClickAdd, onClickView, isUpdate, item }) => {
  let inputElement = null;
  const categoryList = useSelector(
    (state) => state.categoryReducer.categoryList
  );

  const fetchCategoryName = (categoryId) => {
    const category = categoryList?.find(
      (category) => category.category_id === categoryId
    );
    return category ? category.name[lan] : "-";
  };

  inputElement = (
    <>
      <div className={`admin-news-card-wrapper `}>
        {/* <div className="ancw__img">
          <img src={item?.images?.[0]?.url} alt={"news-img"} />
        </div> */}
        <div className={"ancw__body "}>
          <div className={"ancwb__content"}>
            <div>
              <FormHeader
                data={{
                  formHeader: isUpdate
                    ? "(Update) " + item?.title?.[lan]
                    : item?.title?.[lan],
                  size: "xs",
                }}
              />
            </div>
            <div className={"ancwb__c-date"}>
              {item?.created_at
                ? moment(item?.created_at).format("MMMM Do YYYY, h:mm:ss a")
                : moment().format("DD MMMM YYYY")}
            </div>
            <div className={"ancwb__c-subtitle"}>
              {item?.content ? (
                <div
                  className={"ancwb__c-title"}
                  style={{ fontSize: "12px", color: "#c2c2c2" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      item?.content?.[lan].split(/\s+/).slice(0, 15).join(" ") +
                      "...",
                    style: { fontSize: "12px", color: "#c2c2c2" },
                  }}
                ></div>
              ) : (
                <SectionHeader
                  data={{
                    size: "xs",
                    title:
                      item?.content?.[lan].split(/\s+/).slice(0, 15).join(" ") +
                      "...",
                  }}
                />
              )}
            </div>
            <div className={"ancwb__c-tags"}>
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "share",
                  tagName: "100",
                }}
              />
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: item?.views,
                }}
              />
              <Tag
                data={{
                  isIcon: false,
                  tagName: item?.author,
                }}
              />
              <Tag
                data={{
                  isIcon: false,
                  tagName: "Admin",
                }}
              />
              <Tag
                data={{
                  isIcon: false,
                  tagName: fetchCategoryName(item.category),
                }}
              />
            </div>
          </div>
          <div className={"ancwb__action"}>
            <div className={"ancwb__a-link"} onClick={onClickAdd}>
              Add
            </div>
            <div className={"ancwb__a-link"} onClick={onClickEdit}>
              Update
            </div>
            <div className={"ancwb__a-link"} onClick={onClickView}>
              View
            </div>
            <div className={"ancwb__a-link"} onClick={onClickEdit}>
              Edit
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default withRouter(Index);
